var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CampaignActionDomainService from "../Domain/CampaignAction/CampaignAction.service";
import FetchService from "./Shared/FetchService";
import CampaignDomainService, { CampaignLiteDomainService, } from "../Domain/Campaign/Campaign.service";
import AppointmentCampaignInfoDomainService from "../Domain/AppointmentCampaignInfo/AppointmentCampaignInfo.service";
import RRuleDomainService from "../Domain/RRule/RRule.service";
import AutomatedScheduleDomainService from "../Domain/AutomatedSchedule/AutomatedSchedule.service";
import ApplicationCampaignInfoDomainService from "../Domain/ApplicationCampaignInfo/ApplicationCampaignInfo.service";
import EnrollmentCampaignInfoDomainService from "../Domain/EnrollmentCampaignInfo/EnrollmentCampaignInfo.service";
export const CAMPAIGN_ACTIONS = {
    Appointment: {
        id: CampaignActionDomainService.AppointmentId,
        name: "Appointment",
        title: "",
        description: "Encourage students to schedule an appointment with a staff member.",
    },
    Application: {
        id: CampaignActionDomainService.ApplicationId,
        name: "Application",
        title: "",
        description: "Encourage students to update or submit their application.",
    },
    Enrollment: {
        id: CampaignActionDomainService.EnrollmentId,
        name: "Enrollment",
        title: "",
        description: "Encourage students to enroll in classes.",
    },
    General: {
        id: CampaignActionDomainService.GeneralId,
        name: "General",
        title: "",
        description: "Track open and click rates for an email to a list of students",
    },
};
const CAMPAIGN_PATH = "/aviso/campaign";
export default class CampaignService {
    static getAction(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(CAMPAIGN_PATH + "/getAction", { id });
        });
    }
    static save(body) {
        var _a;
        if (((_a = body === null || body === void 0 ? void 0 : body.automatedSchedule) === null || _a === void 0 ? void 0 : _a.scheduleType) ===
            AutomatedScheduleDomainService.ScheduleType.RRuleAutomatedSchedule) {
            return FetchService.postSingleResponse(CAMPAIGN_PATH + "/save", Object.assign(Object.assign({}, body), { automatedSchedule: Object.assign(Object.assign({}, body.automatedSchedule), { rrule: RRuleDomainService.toString(body.automatedSchedule.rrule) }) }));
        }
        return FetchService.postSingleResponse(CAMPAIGN_PATH + "/save", body);
    }
    static search(search = {}, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield FetchService.getPagedResponse(CAMPAIGN_PATH + "/search", {
                query: search === null || search === void 0 ? void 0 : search.query,
                names: search === null || search === void 0 ? void 0 : search.names,
                isDragAndDrop: search === null || search === void 0 ? void 0 : search.isDragAndDrop,
                sendToInstitutionalEmail: search === null || search === void 0 ? void 0 : search.sendToInstitutionalEmail,
                sendToPersonalEmail: search === null || search === void 0 ? void 0 : search.sendToPersonalEmail,
                senderIds: search === null || search === void 0 ? void 0 : search.senderIds,
                createdByIds: search === null || search === void 0 ? void 0 : search.createdByIds,
                createdDateTo: search === null || search === void 0 ? void 0 : search.createdDateTo,
                createdDateFrom: search === null || search === void 0 ? void 0 : search.createdDateFrom,
                modifiedByIds: search === null || search === void 0 ? void 0 : search.modifiedByIds,
                modifiedDateTo: search === null || search === void 0 ? void 0 : search.modifiedDateTo,
                modifiedDateFrom: search === null || search === void 0 ? void 0 : search.modifiedDateFrom,
                expirationDateTo: search === null || search === void 0 ? void 0 : search.expirationDateTo,
                expirationDateFrom: search === null || search === void 0 ? void 0 : search.expirationDateFrom,
                messageTemplateIds: search === null || search === void 0 ? void 0 : search.messageTemplateIds,
                lastExecutionDateTo: search === null || search === void 0 ? void 0 : search.lastExecutionDateTo,
                lastExecutionDateFrom: search === null || search === void 0 ? void 0 : search.lastExecutionDateFrom,
                campaignTypeIds: search === null || search === void 0 ? void 0 : search.campaignTypeIds,
                startedDateTo: search === null || search === void 0 ? void 0 : search.startedDateTo,
                startedDateFrom: search === null || search === void 0 ? void 0 : search.startedDateFrom,
                deletedDateTo: search === null || search === void 0 ? void 0 : search.deletedDateTo,
                deletedDateFrom: search === null || search === void 0 ? void 0 : search.deletedDateFrom,
                deletedByIds: search === null || search === void 0 ? void 0 : search.deletedByIds,
                startedByIds: search === null || search === void 0 ? void 0 : search.startedByIds,
                sendBehaviors: search === null || search === void 0 ? void 0 : search.sendBehaviors,
                fromEmailAddressIds: search === null || search === void 0 ? void 0 : search.fromEmailAddressIds,
                campaignContentTemplateIds: search === null || search === void 0 ? void 0 : search.campaignContentTemplateIds,
                virtualizedAppName: search === null || search === void 0 ? void 0 : search.virtualizedAppName,
                personTypeInternalName: search === null || search === void 0 ? void 0 : search.personTypeInternalName,
                isStarted: search === null || search === void 0 ? void 0 : search.isStarted,
                isStopped: search === null || search === void 0 ? void 0 : search.isStopped,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                lite: options.lite,
            });
            if (options.lite) {
                // @ts-expect-error - TS2322 - Type '{ data: unknown; total: number; maxResults: number; offset: number; }' is not assignable to type 'PagedResult<Campaign[]>'.
                return Object.assign({}, response);
            }
            return Object.assign(Object.assign({}, response), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: response.data.map(CampaignDomainService.fromJSON) });
        });
    }
    static startCampaign(campaignId) {
        return FetchService.postSingleResponse(CAMPAIGN_PATH + "/startCampaign", {
            campaignId,
        }).then(CampaignDomainService.fromJSON);
    }
    static deleteCampaign(campaignId) {
        return FetchService.deleteSingleResponse(CAMPAIGN_PATH + "/deleteCampaign", {
            campaignId,
        }).then(CampaignDomainService.fromJSON);
    }
    static get(id) {
        return FetchService.getSingleResponse(CAMPAIGN_PATH + "/get", { id }).then(CampaignDomainService.fromJSON);
    }
    static getAppointmentCampaignInfo(id) {
        // @ts-expect-error - TS2322 - Type 'Promise<AppointmentCampaign | ApplicationCampaign | EnrollmentCampaign | GeneralCampaign>' is not assignable to type 'Promise<AppointmentCampaign>'.
        return FetchService.getSingleResponse(CAMPAIGN_PATH + "/getAppointmentInfoFromCampaign", { id }).then(CampaignDomainService.fromJSON);
    }
    static getAppointmentCampaignLiteInfo(id) {
        // @ts-expect-error - TS2322 - Type 'Promise<AppointmentCampaign | ApplicationCampaign | EnrollmentCampaign | GeneralCampaign>' is not assignable to type 'Promise<AppointmentCampaign>'.
        return FetchService.getSingleResponse(CAMPAIGN_PATH + "/getAppointmentInfoFromCampaignLite", { id }).then(CampaignLiteDomainService.fromJSON);
    }
    static getApplicationCampaignInfo(id) {
        // @ts-expect-error - TS2322 - Type 'Promise<AppointmentCampaign | ApplicationCampaign | EnrollmentCampaign | GeneralCampaign>' is not assignable to type 'Promise<ApplicationCampaign>'.
        return FetchService.getSingleResponse(CAMPAIGN_PATH + "/getApplicationInfoFromCampaign", { id }).then(CampaignDomainService.fromJSON);
    }
    static getEnrollmentCampaignInfo(id) {
        // @ts-expect-error - TS2322 - Type 'Promise<AppointmentCampaign | ApplicationCampaign | EnrollmentCampaign | GeneralCampaign>' is not assignable to type 'Promise<EnrollmentCampaign>'.
        return FetchService.getSingleResponse(CAMPAIGN_PATH + "/getEnrollmentInfoFromCampaign", { id }).then(CampaignDomainService.fromJSON);
    }
    static getCampaignEmailItemStatuses() {
        return FetchService.getSingleResponse(CAMPAIGN_PATH + "/getCampaignStatuses");
    }
    static sendTestEmail(campaignId, email) {
        return FetchService.postSingleResponse(CAMPAIGN_PATH + "/sendTestEmail", {
            id: campaignId,
            email,
        });
    }
    static getCampaignTypeInfo(campaignTypeId, campaignId) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (campaignTypeId) {
                case CampaignActionDomainService.AppointmentId: {
                    const info = yield CampaignService.getAppointmentCampaignInfo(campaignId);
                    return AppointmentCampaignInfoDomainService.getInfoTextFields(info);
                }
                case CampaignActionDomainService.ApplicationId: {
                    const info = yield CampaignService.getApplicationCampaignInfo(campaignId);
                    return ApplicationCampaignInfoDomainService.getInfoTextFields(info);
                }
                case CampaignActionDomainService.EnrollmentId: {
                    const info = yield CampaignService.getEnrollmentCampaignInfo(campaignId);
                    return EnrollmentCampaignInfoDomainService.getInfoTextFields(info);
                }
                case CampaignActionDomainService.GeneralId:
                default:
                    return [];
            }
        });
    }
    static enrollOpportunitiesInCampaign(opportunityIds, campaignId) {
        return FetchService.postSingleResponse(CAMPAIGN_PATH + "/enrollOpportunitiesInCampaign", {
            opportunityIds,
            campaignId,
        });
    }
    static stopCampaign(campaignId) {
        return FetchService.postSingleResponse(CAMPAIGN_PATH + "/stopCampaign", {
            campaignId,
        }).then(CampaignDomainService.fromJSON);
    }
    static editAutomatedSchedule(body) {
        return FetchService.postSingleResponse(CAMPAIGN_PATH + "/editAutomatedSchedule", Object.assign(Object.assign({}, body), { automatedSchedule: Object.assign(Object.assign({}, body.automatedSchedule), { rrule: RRuleDomainService.toString(body.automatedSchedule.rrule) }) })).then(CampaignDomainService.fromJSON);
    }
}
